import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import markdownit from 'markdown-it'
import BeautifulSoup from 'beautiful-soup-js'
import dataService from '../components/data.service'
import { GoogleTranslator } from '@translate-tools/core/translators/GoogleTranslator'

Vue.use(Vuex)

const translator = new GoogleTranslator()
const markdownIt = markdownit({
  html: true
})

const state = {
  camps: [],
  campTypes: [],
  ageRanges: [],
  locations: [],
  categories: [],
  startDates: [],
  engDescription: [],
  engTitle: [],
  engCategories: [],
  siteText: null,
  engSiteText: null,
  siteLoading: null,
  dataLoading: null,
  translateLoading: null
}

const store = new Vuex.Store({
  state,
  getters: {
    camps: (state) => {
      return state.camps
    },
    campTypes: (state) => {
      return state.campTypes
    },
    ageRanges: (state) => {
      return state.ageRanges
    },
    locations: (state) => {
      return state.locations
    },
    categories: (state) => {
      return state.categories
    },
    startDates: (state) => {
      return state.startDates
    },
    engDescription: (state) => {
      return state.engDescription
    },
    engTitle: (state) => {
      return state.engTitle
    },
    engCategories: (state) => {
      return state.engCategories
    },
    siteText: (state) => {
      return state.siteText
    },
    engSiteText: (state) => {
      return state.engSiteText
    },
    siteLoading: (state) => {
      return state.siteLoading
    },
    dataLoading: (state) => {
      return state.dataLoading
    },
    translateLoading: (state) => {
      return state.translateLoading
    }
  },
  actions: {
    getCamps (context) {
      context.commit('dataLoading', true)
      dataService.getCampListing().then(data => {
      // dataService.getCamps().then(data => {
        context.commit('getCamps', data)
      })
    },
    getSiteText (context) {
      context.commit('siteLoading', true)
      dataService.getSiteText().then(data => {
        context.commit('getSiteText', data)
      })
    },
    translateCamps (context, data) {
      context.commit('translateLoading', true)
      context.commit('translateCamps', data)
    }
  },
  mutations: {
    getSiteText (state, data) {
      let htmlContent = markdownIt.render(data[0].pageText)
      state.siteText = data && data.length > 0 ? htmlContent : []
      state.engSiteText = state.siteText
      state.siteLoading = false
    },
    getCamps (state, data) {
      var campTypes = []
      var ageRanges = ['All Ages', 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21]
      var locations = []
      var categories = []
      var allDates = []
      data.forEach(camp => {
        campTypes.push(camp['Camp Type'])
        locations.push(camp['Location'])
        categories.push(camp['Category'])
        allDates.push(camp['Date Range'])
        if (camp['Registration Website'] !== null) {
          if (camp['Registration Website'].indexOf('http') === -1) {
            camp['Registration Website'] = 'http://' + camp['Registration Website']
          }
        }
      })

      var activeCamps = data.filter(function (camp) {
        return camp['Program Status'] === 'Active'
      })

      state.camps = _.sortBy(activeCamps, ['Official Title'])

      allDates = _.sortBy(_.uniq(allDates))
      var startDates = []
      allDates.forEach(adate => {
        if (adate != null) {
          startDates.push(new Date(adate.substring(0, adate.indexOf(' -'))))
        }
      })

      startDates.sort((a, b) => a - b)

      state.campTypes = _.sortBy(_.uniq(campTypes))
      state.ageRanges = ageRanges
      state.locations = _.sortBy(_.uniq(locations))
      state.categories = _.sortBy(_.uniq(categories))
      state.startDates = _.uniq(startDates.map(d => { return new Date(d).toLocaleDateString('en-US', {timeZone: 'UTC'}) }))
      state.engDescription = state.camps.map(a => a['Camp Description'])
      state.engCategories = state.camps.map(a => a.Category)
      state.dataLoading = false
    },
    async translateCamps (state, data) {
      if (data !== 'en') {
        let categoryArray = state.engCategories
        let uniqCatArr = _.uniq(categoryArray)
        let translatedCategories = await translator.translateBatch(uniqCatArr, 'en', data)

        let descriptionArray = state.engDescription
        let translatedDescriptions = await translator.translateBatch(descriptionArray, 'en', data)

        // use beautifulsoup to update html
        var soup = new BeautifulSoup(state.engSiteText)
        var tags = soup.findAll(
          { attrs: {class: 'translateText'} }
        )
        let siteTextArray = tags.flatMap(a => a.contents.map(b => {
          return b.hasOwnProperty('contents') ? b.contents[0].text : b.text
        }))
        let translatedSiteTextArray = await translator.translateBatch(siteTextArray, 'en', data)

        let pos = 0
        let newTags = []
        tags.forEach(tag => {
          let newTag = {...tag}
          newTag = newTag.contents.map(b => {
            if (!b.text) {
              b.contents.map(c => {
                c.text = translatedSiteTextArray[pos]
                pos++
                return c
              })
            } else {
              b.text = translatedSiteTextArray[pos]
              pos++
            }
            return b
          })
          newTags.push(newTag)
        })
        tags = newTags
        state.siteText = soup.prettify()

        for (let i = 0; i < state.camps.length; i++) {
          state.camps[i]['Camp Description'] = translatedDescriptions[i]
          let catInd = uniqCatArr.indexOf(state.camps[i]['Category'])
          state.camps[i]['Translated Category'] = translatedCategories[catInd]
        }
      } else {
        state.camps.map((camp, index) => {
          camp['Camp Description'] = state.engDescription[index]
          camp['Category'] = state.engCategories[index]
          camp['Translated Category'] = null
        })
        state.siteText = state.engSiteText
      }
      state.translateLoading = false
    },
    translateLoading (state, loadingStatus) {
      state.translateLoading = loadingStatus
    },
    dataLoading (state, loadingStatus) {
      state.dataLoading = loadingStatus
    },
    siteLoading (state, loadingStatus) {
      state.siteLoading = loadingStatus
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js